// extracted by mini-css-extract-plugin
export default {"select-box":"SelectBoxForm_select-box__FQ8vq"};